import React, { useEffect, useRef, useState } from 'react'
import CatalogGoodContainer from '@mobileComponents/catalog/CatalogGoodContainer/CatalogGoodContainer'
import CatalogGroupList from '@mobileComponents/catalog/CatalogGroupList/CatalogGroupList'
import PropTypes from 'prop-types'
import MobileHeader from '@mobileShared/MobileHeader/MobileHeader'
import { ScrollBody } from 'src/shared/ui/mobile/scroll-body'
import { useStore } from 'effector-react'
import { $shipment } from '@entities/shipment/model'
import { $groups } from 'src/features/goods-groups-update/model'
import { useGroupById } from 'src/features/goods-groups-update/hooks'
import dynamic from 'next/dynamic'

const FilterSortBlockGoods = dynamic(() => import('src/features/filter-goods').then((x) => x.FilterSortBlockGoods), {
    ssr: false
})

const MobileGroupPage = (props) => {
    const groups = useStore($groups)
    const shipment = useStore($shipment)
    const [heightHeader, setHeightHeader] = useState(84)
    const group = useGroupById(props.groupId)
    const blockHeaderRef = useRef(null)
    useEffect(() => {
        if (blockHeaderRef?.current?.getBoundingClientRect().height !== heightHeader)
            setHeightHeader(blockHeaderRef?.current?.getBoundingClientRect().height)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [blockHeaderRef?.current?.clientHeight, shipment.shipAddressId])
    const scrollRef = useRef(null)

    return (
        <React.Fragment>
            <MobileHeader
                blockRef={blockHeaderRef}
                searchInput={{
                    isShowed: true
                }}>
                {group?.title || 'Каталог'}
            </MobileHeader>
            <ScrollBody scrollRef={scrollRef}>
                {groups.length > 0 ? <CatalogGroupList>{groups}</CatalogGroupList> : <React.Fragment />}
                <FilterSortBlockGoods targetRef={scrollRef} />
                <CatalogGoodContainer groupId={props.groupId} />
            </ScrollBody>
        </React.Fragment>
    )
}
MobileGroupPage.propTypes = {
    groupId: PropTypes.number.isRequired
}

export default MobileGroupPage
